import {
  CSP_NONCE,
  Provider,
  EnvironmentProviders,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { RouterStateSerializer } from '@ngrx/router-store';
import { OKTA_CONFIG } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';

import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { CustomSerializer } from './store/reducers/router.reducer';
import { NonceService } from './core/services/nonce';
import { TokenInterceptor } from './core/token.interceptor';
import config from './app.config';

export const googleMeasurementId = environment.production
  ? 'G-S1MYCEH0GM'
  : 'G-8V2BK3ZR53';

function nonceInitializerFactory(
  nonceService: NonceService,
): () => Promise<void> {
  return () => nonceService.getNonce().then(() => {});
}

function cspNonceFactory(nonceService: NonceService): string {
  return nonceService.getCachedNonce();
}

const oktaAuth = new OktaAuth(config.oidc);

export const initializeAppProviders: (Provider | EnvironmentProviders)[] = [
  { provide: RouterStateSerializer, useClass: CustomSerializer },
  { provide: OKTA_CONFIG, useValue: { oktaAuth } },
  { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
  { provide: 'googleTagManagerId', useValue: googleMeasurementId },
  provideAppInitializer(() => {
    const initializerFn = nonceInitializerFactory(inject(NonceService));
    return initializerFn();
  }),
  {
    provide: 'googleTagManagerCSPNonce',
    useFactory: cspNonceFactory,
    deps: [NonceService],
  },
];
